export default __webpack_public_path__ + "static/media/tickets-ticket.2cf7a0eb.gif";